/**
 * Config Category Metadata
 *
 * Human-readable labels and descriptions for config categories.
 * Used in admin UI for display.
 */

import type { ConfigCategory } from "./zsystem-config";

export const CONFIG_CATEGORY_METADATA: Record<
  ConfigCategory,
  { label: string; description: string }
> = {
  cron: {
    label: "Cron Jobs",
    description: "Scheduled task configurations"
  },
  rate_limit: {
    label: "Rate Limits",
    description: "API rate limiting configurations"
  },
  cache: {
    label: "Cache",
    description: "Cache TTL and size configurations"
  },
  circuit_breaker: {
    label: "Circuit Breakers",
    description: "Fault tolerance configurations"
  },
  retry_policy: {
    label: "Retry Policies",
    description: "Retry behavior configurations"
  },
  echo: {
    label: "Echo",
    description: "Global Echo subsystem settings"
  },
  deletion: {
    label: "Deletion",
    description: "Soft- vs hard-delete policy per entity (Agent, Deployment)"
  },
  conversation: {
    label: "Conversations",
    description: "Conversation lifecycle & outcome-capture settings"
  },
  vibe: {
    label: "Vibe",
    description: "Global Vibe subsystem settings (per-tenant cluster policy)"
  },
  public_api: {
    label: "Public API",
    description: "Public API operational settings (v1 response-contract validation mode)"
  },
  twilio: {
    label: "Twilio",
    description: "Twilio Operator Console settings (number release cooling-window duration)"
  },
  agent_auth: {
    label: "Agent Auth (auth.md)",
    description:
      "Which auth.md registration entrypoints agents may use — sign-in (service_auth) and sign-up (anonymous)"
  },
  sandbox: {
    label: "Sandbox",
    description:
      "Daytona sandbox snapshot bake settings (which @agent-nexus/cli version an image installs)"
  },
  deployments: {
    label: "Deployments",
    description:
      "Inbound channel-webhook settings (Teams Bot Framework authentication: enforce vs log)"
  },
  "agent-tools": {
    label: "Agent Tools",
    description: "Agent tool settings (input-schema validation enforcement mode at save time)"
  },
  identity: {
    label: "Identity",
    description:
      "What an UNPROVEN identity claim may buy — the identification stamp, Contacts visibility for a volunteered handle, and whether an empty record may win a merge. Platform-wide; the per-deployment switch is the embed's identity verification."
  }
};
